<div class="modal-header">
  <h4 class="modal-title" id="modal-title">{{ 'emailCommunication.sendMessage' | translate }}</h4>
  <button
    type="button"
    class="close"
    aria-label="Close button"
    aria-describedby="modal-title"
    (click)="modal.dismiss('')"
  >
    <span class="fas fa-times"></span>
  </button>
</div>
<div class="modal-body">
  <div class="onboarding-content">
    <form [formGroup]="productForm" novalidate>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label for="field1">{{ 'emailCommunication.composeMessage' | translate }}</label>
            <textarea
              class="form-control border-main p-3 w-100 h-100"
              placeholder=""
              rows="4"
              formControlName="message"
            ></textarea>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Abbrechen</button>
  <button type="button" ngbAutofocus class="btn btn-primary" (click)="onConfirm()">{{ buttonText }}</button>
</div>
